import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    content: {
      paddingTop: 0,

      '& > ul': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
        padding: 0,

        '& > li': {
          display: 'grid',
          alignItems: 'center',
          gridTemplateColumns: '1fr 1.4fr auto',

          borderRadius: '0.5rem',
          padding: theme.spacing(1.5),

          '& > *:nth-child(2)': {
            textAlign: 'center',
          },
        },
      },
    },
    background: {
      backgroundColor: theme.palette.background.default,
    },
    actions: {
      paddingTop: theme.spacing(1.5),
      paddingBottom: 0,

      '& > .MuiButtonBase-root': {
        marginTop: 0,
        width: 'max-content',
      },
    },
  }),
)
